'use client';

import DocumentPageShell from '@/components/sections/shared/DocumentPageShell';

function SkeletonBlock({ className }: { className: string }) {
  return <div className={`animate-pulse rounded-[10px] bg-gray-200 ${className}`} />;
}

export default function AnnualReturnSkeleton() {
  return (
    <DocumentPageShell
      eyebrow="Resources"
      title="Annual Return"
      subtitle={<SkeletonBlock className="h-5 w-3/4" />}
    >
      <div className="overflow-hidden rounded-2xl border border-[#e4e4e4] bg-white p-5 shadow-sm sm:p-6 md:p-8">
        <div className="mb-6 border-b border-[#f0f0f0] pb-6">
          <SkeletonBlock className="h-4 w-24" />
          <SkeletonBlock className="mt-2 h-7 w-56" />
        </div>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {[0, 1, 2, 3, 4, 5].map((i) => (
            <SkeletonBlock key={i} className="h-[220px] rounded-2xl" />
          ))}
        </div>
      </div>
    </DocumentPageShell>
  );
}
